
import { Difficulty } from './types.js';

export const GRID_SIZE = 20;
export const MIN_SPEED = 50;
export const POWER_UP_SPAWN_INTERVAL = 5; // Every 5 whispers
export const POWER_UP_DURATION = 5000; // 5 seconds in ms

export const DIFFICULTY_SETTINGS = {
  [Difficulty.EASY]: {
    INITIAL_SPEED: 250,
    SPEED_INCREMENT_FACTOR: 0.99,
  },
  [Difficulty.MEDIUM]: {
    INITIAL_SPEED: 200,
    SPEED_INCREMENT_FACTOR: 0.98,
  },
  [Difficulty.HARD]: {
    INITIAL_SPEED: 150,
    SPEED_INCREMENT_FACTOR: 0.97,
  },
};

export const INITIAL_SNAKE_POSITION = [
  { x: 10, y: 10 },
  { x: 9, y: 10 },
  { x: 8, y: 10 },
];
